export default "__VITE_ASSET__CrlbhmmD__"